import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class BluesnapRepository {
  constructor(private apiService: ApiService) {}

  public paymentStatusNotification(billId: number, state: string, transactionId: string): Observable<{}> {
    return this.apiService.post<{}>(`${environment.url.bluesnap}callback/paymentstatusnotification`, { billId, state, transactionId });
  }

  public encryptParams(params: { [param: string]: string }): Observable<string> {
    return this.apiService.post<string>(`${environment.url.bluesnap}param-encryption`, params, {
      responseType: 'text',
    });
  }
}
